import { render } from "./AppPopupPage.vue?vue&type=template&id=cdeabda6&bindings={\"close\":\"props\",\"light\":\"props\",\"handleClose\":\"options\"}"
import script from "./AppPopupPage.vue?vue&type=script&lang=js"
export * from "./AppPopupPage.vue?vue&type=script&lang=js"
script.render = render

export default script